import {faCartShopping} from '@fortawesome/pro-regular-svg-icons';
import useTranslation from 'next-translate/useTranslation';

import AppBarIconButton from '../AppBarIconButton';

type CartButtonProps = Omit<
  React.ComponentProps<typeof AppBarIconButton>,
  'icon' | 'title' | 'aria-label'
>;

const CartButton: React.FC<CartButtonProps> = props => {
  const {t} = useTranslation('app-bar');

  return (
    <AppBarIconButton
      aria-label={t('cart.label')}
      icon={faCartShopping}
      title={t('cart.label')}
      variant="secondary"
      {...props}
    />
  );
};

export default CartButton;
